<template>

  <v-app id="inspire" class="app-themed" :class="{ 'app-with-chat': canUseChat }">

    <NavBar v-if="$store.getters.systemLoad" />
  
    <OverLay/>

    <Loading/> 

    <ModuleEditorDialogHost />
    <FieldEditorDialogHost />
    <ActionEditorDialogHost />
    <RightsEditorDialogHost />
    <TabulationEditorDialogHost />
    <GuideRoot v-if="$store.getters.systemLoad && $store.getters.currentUser.public === false" />
    <ChatRoot v-if="canUseChat" />
    
    <modal-template v-for="v in $store.getters['show']" :key="v.current" :current="v.current" :visible="v.show"></modal-template>
         <!--$route.fullPath permet de rafraichir si un meme composant est apelé -->
    <v-main class="app-theme-page">
      <router-view :key="keyApp()"> </router-view>
    </v-main>
        

  </v-app>

</template>

<script>
import NavBar  from './components/main/navbar.vue'
import OverLay  from './components/outils/overlay.vue'

import Loading from './components/outils/loading'
import ModuleEditorDialogHost from './components/engine/editModule/DialogHost.vue'
import FieldEditorDialogHost from './components/engine/editField/DialogHost.vue'
import ActionEditorDialogHost from './components/engine/editAction/DialogHost.vue'
import RightsEditorDialogHost from './components/engine/editDroits/DialogHost.vue'
import TabulationEditorDialogHost from './components/modules/tabulations/DialogHost.vue'
import ChatRoot from './components/chat/ChatRoot.vue'
import GuideRoot from './components/engine/guide/GuideRoot.vue'
import chatApi from './services/api'
  export default {
    name : 'AppComponent',

    props : ['url'],

        components: { 

          NavBar,
          Loading,
          OverLay,
          ModuleEditorDialogHost,
          FieldEditorDialogHost,
          ActionEditorDialogHost,
          RightsEditorDialogHost,
          TabulationEditorDialogHost,
          ChatRoot,
          GuideRoot,
          },

        data: function() {
            return {
              lastActivity: Date.now(),           
              afkInterval: null,
              presenceIdentity: null,
              presenceChannels: [],
              applicationChannelIdentity: null,
            }
        },

        computed: {
          canUseChat() { return this.$store.getters.systemLoad && this.$store.getters.currentUser.public === false && !!this.$store.getters.currentUser.uuid }
        },


        watch : {

        '$route.path'() {

          // Conserver la demande de cette navigation, effacer celles d'une ancienne page.
          this.$store.dispatch('reconcilePendingActiveTabsNavigation', {
            token: this.$route.params && this.$route.params.__activeTabsNavigation
          });

          this.$store.dispatch('purgeModal');
          this.$store.dispatch('removeAllForm');
          this.$store.dispatch('removeAllIForms');
          this.$store.dispatch('removeAllConditions');
          
        },

        '$store.getters.systemLoad'(val) {
          if (val && this.canUseChat) {

            this.trackUserActivity();
            this.initPresenceChannel();

          } else {
            //console.log('not loaded')
            this.stopAfkWatcher()
          }
        }
        },

        methods : {

          keyApp() {
            
            if(!this.$route.query.global) return this.$route.path;
          },

          async initPresenceChannel() {
            if (!this.canUseChat || !this.$echo() || !this.$presenceEcho()) return
            const user = this.$store.getters.currentUser
            const identity = user.uuid + ':' + user.entreprise
            if (this.presenceIdentity === identity) return
            this.presenceIdentity = identity
            if (this.applicationChannelIdentity !== identity) {
              this.applicationChannelIdentity = identity
              this.$echo().private(`user.${user.uuid}`)
              .stopListening('.deconnect')
              .listen('.deconnect', () => this.$store.dispatch('logOut'))
              .stopListening('.notifications')
              .listen('.notifications', e => this.$store.dispatch('getNotifications', e))
              this.$echo().private(`entreprise.${user.cpnID}`)
              .stopListening('.notifications')
              .listen('.notifications', e => this.$store.dispatch('getNotifications', e))
            }
            try {
              const { data } = await chatApi.get('chat/presence')
              if (identity !== this.presenceIdentity || !this.canUseChat) return
              this.presenceChannels = data.channels
              for (const scope of data.channels) {
                this.$presenceEcho().join(scope)
                  .here(users => this.$store.dispatch('getConnectedUsers', {scope, users}))
                  .joining(person => this.$store.dispatch('joinUser', {scope, user:person}))
                  .leaving(person => this.$store.dispatch('leaveUser', {scope, user:person}))
                  .listen('.user.activity.updated', e => {
                    const person = this.$store.getters.connectedUsers.find(p => Number(p.uuid) === Number(e.user_id) && p.entreprise === e.entreprise)
                    if (!person) return
                    this.$set(person, 'lastpage', e.lastpage)
                    if ((e.isAfk && !person.isAfk) || !e.isAfk) this.$set(person, 'lastUpdate', e.timestamp)
                    if (e.isAfk !== undefined) this.$set(person, 'isAfk', e.isAfk)
                  })
              }
            } catch (error) { this.presenceIdentity = null }
          },

          trackUserActivity() {

            //window.addEventListener('keydown', this.onTyping)
            window.addEventListener('mousemove', this.onActive)
            window.addEventListener('click', this.onActive)
            window.addEventListener('keydown', this.onActive)
            window.addEventListener('touchstart', this.onActive, { passive: true })
            this.startAfkWatcher()
          },

          onActive() {
            this.lastActivity = Date.now()
          },

          startAfkWatcher() {
            if (this.afkInterval) clearInterval(this.afkInterval)

            this.afkInterval = setInterval(() => {
              if (!this.presenceIdentity) this.initPresenceChannel()
              const now = Date.now()
              const inactiveMs = now - this.lastActivity
              if (inactiveMs > 2 * 60 * 1000) { // 2 minutes
                this.$store.dispatch('updateInactivState',true)
                this.sendActivity({ isAfk: true })
              } else {
                this.$store.dispatch('updateInactivState',false)
                this.sendActivity({ isAfk: false })
              }
            }, 60 * 1000) // vérifie chaque minute
          }, 
          
          stopAfkWatcher() {
            window.removeEventListener('mousemove', this.onActive)
            window.removeEventListener('click', this.onActive)
            window.removeEventListener('keydown', this.onActive)
            window.removeEventListener('touchstart', this.onActive)
            for (const scope of this.presenceChannels || []) this.$presenceEcho()?.leave(scope)
            this.presenceChannels = []
            this.presenceIdentity = null
            this.applicationChannelIdentity = null
            this.$store.dispatch('getConnectedUsers', [])
            if (this.afkInterval) {
              clearInterval(this.afkInterval)
              this.afkInterval = null
            }
          },

          sendActivity(data) {
            let options = {...{type:'checkpresence'}, ...data}
            this.API({type:'post', url:'engine/sendsocket', params:options})
          }
        },

        mounted()  {
          /*
      if (this.$store.getters.currentUser) {
        this.initPresenceChannel()
      } */


        },

        created() {

        }


  }
</script>

<style>
@media (min-width: 960px) {
  .app-with-chat > .v-application--wrap > .v-main > .v-main__wrap { min-width: 0; margin-right: 56px; }
}
@media (prefers-reduced-motion: reduce) {
  .chat-root *, .chat-dialog * { scroll-behavior: auto !important; transition: none !important; animation: none !important; }
}
</style>
